import { useMemo, useState } from 'react';
import { Search as SearchIcon } from 'lucide-react';
import { MOVIES } from '@/shared/data';
import { MovieCard } from './components/MovieCard';

export function Search() {
  const [q, setQ] = useState('');
  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    if (!term) return MOVIES;
    return MOVIES.filter(
      (m) =>
        m.title.toLowerCase().includes(term) ||
        m.genres.some((g) => g.toLowerCase().includes(term)),
    );
  }, [q]);

  return (
    <div data-testid="movieflix-search" className="px-4">
      <div className="pb-3">
        <div className="glass rounded-full flex items-center gap-2 px-4 py-2.5">
          <SearchIcon className="w-4 h-4 text-white/40" />
          <input
            data-testid="search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search Movieflix"
            className="bg-transparent flex-1 outline-none text-sm placeholder:text-white/40"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {filtered.map((m) => (
          <MovieCard key={m.id} movie={m} variant="portrait" />
        ))}
      </div>
    </div>
  );
}
